<template>
    <div class="module renew-content">
        <helpInfo :helpData="helpData"></helpInfo>
        <!--续费提示语-->
        <div class="module-container"
             style="padding-top:0px;">
            <!--复制ID-->
            <input ref="copyrelay"
                   v-model="copyId"
                   class="copy-el" />
            <div class="hint">
                <i class="icon-prompt-1-o"
                   style="color:#2d8cf0"></i>
                <div class="hintFont">
                    <p>{{$t('默认显示最近3个月内到期资源，如果想提前续费3个月以上资源则可以通过对应的产品资源功能进行操作。')}}</p>
                </div>
            </div>
            <ul class="searchCondition">
                <li>
                    <label>{{$t('时间')}}：</label>
                    <p>
                        <span v-for="(item,index) in searchTime"
                              :key="index"
                              :class="(countdown===searchTime[index].value)?'curr':''"
                              @click="searchClick(searchTime[index].value,'countdown')">
                            {{$t(item.name)}}
                        </span>
                    </p>
                </li>
                <li>
                    <label>{{$t('产品类型')}}：</label>
                    <p>
                        <span v-for="(item,index) in products"
                              :key="index"
                              :class="(productType===products[index].productType)?'curr':''"
                              @click="searchClick(products[index].productType,'type')">
                            {{$t(item.productName)}}
                        </span>
                    </p>
                </li>
                <li v-show="$store.state.app.cloudConfigShow">
                    <label>{{$t('云环境')}}：</label>
                    <p>
                        <span v-for="(item,index) in cloud"
                              :key="index"
                              :class="(cloudEnvId===cloud[index].cloudEnvId)?'curr':''"
                              @click="searchClick(cloud[index].cloudEnvId,'cloudEnv')">
                            {{item.cloudEnvName}}
                        </span>
                    </p>
                </li>
                <li>
                    <label>{{$t('项目')}}：</label>
                    <p>
                        <Select v-model="projectId"
                                @on-change="projectClick"
                                style="margin:0 0 0 7px;width:200px">
                            <Option v-for="item in projectList"
                                    :value="item.id"
                                    :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </p>
                </li>
            </ul>
            <rcTable ref="rcTable"
                     :tableAttr="tableAttr"
                     v-if="hasPermission('CC0801')"
                     @onSelectChange="selectedChange">
                <Button slot="tootipL"
                        @click="refresh">
                    <i class="icon-refresh-o-2"></i>
                </Button>
                <Button @click="renewClick('automatic')"
                        slot="tootipL"
                        :disabled="!selected.length||!hasPermission('CC0802')||isAutomatic"
                        type="primary">
                    {{$t('设置自动续费')}}
                </Button>
                <Button @click="renewClick('noRenew')"
                        slot="tootipL"
                        :disabled="!selected.length||!hasPermission('CC0803')||isNoRenew"
                        type="primary">
                    {{$t('到期不续费')}}
                </Button>
                <Button @click="renewClick('export')"
                        :disabled="!hasPermission('CC0804')"
                        slot="tootipL">
                    <i class="icon-export-1-o"></i>
                    {{$t('导出')}}
                </Button>
                <Button @click="renewClick('expireDate')"
                        slot="tootipR">
                    {{$t('设置统一到期时间')}}
                    <Tooltip :content="$t('目前统一到期时间不支持公有云续费设置。')"
                             theme="light"
                             placement='right'>
                        <i class="icon-prompt-1-o tips-style"
                           style="color:#2d8cf0"></i>
                    </Tooltip>
                </Button>
            </rcTable>
        </div>
        <div v-if="loading"
             style="height: 100%">
            <Spin fix><span>{{$t(loadingTxt)}}...</span></Spin>
        </div>

        <!-- 设置统一到期时间 -->
        <expirationtime ref="expirationtime" />
    </div>
</template>

<script>
import helpInfo from '@c/basic/helpinfo'
import rcTable from '@/views/components/basic/rcTable'
import API from '@/service/api'
import expirationtime from './components/expirationtime'
export default {
    name: 'renew',
    components: {
        helpInfo,
        rcTable,
        expirationtime
    },
    data () {
        return {
            helpData: {
                modelName: this.$t('续费管理')
            },
            loading: true,
            loadingTxt: '加载中',
            copyId: null,
            projectId: 'all',
            projectList: [],
            dayNumber: 3,
            renewType: [], // 续费状态类型
            selected: [], // 所选
            isNoRenew: false,
            isAutomatic: false,
            countdown: 'all',
            productType: 'all',
            cloudEnvId: 'all',
            searchTime: [
                { value: 'all', name: '全部' },
                { value: '7', name: '7天内到期' },
                { value: '15', name: '15天内到期' },
                { value: '30', name: '30天内到期' },
                { value: '60', name: '2个月内到期' },
                { value: '90', name: '3个月内到期' }
            ],
            products: [],
            cloud: [],
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.RENEW, false),
                    params: {
                        countdown: null, // 倒计时
                        productType: null, // 产品类型
                        cloudEnvId: null // 云环境id
                    }
                },
                columnsChooseShow: true,
                searchShow: true,
                isMultiSelect: true,
                searchColumns: [
                    {
                        key: 'nameLike',
                        title: this.$i18n.t('名称'),
                        searchDefaultValue: ''
                    },
                    {
                        key: 'idLike',
                        title: 'ID',
                        searchDefaultValue: ''
                    }
                ],
                referenceVal: 1310,
                columns: [
                    {
                        title: this.$t('产品'),
                        key: 'productName',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        render: (h, params) => {
                            return h('span', {
                                attrs: {
                                    title: params.row.productName
                                }
                            }, this.$t(params.row.productName))
                        }
                    },
                    {
                        title: this.$t('名称') + '/ID',
                        key: 'id',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 200,
                        render: (h, params) => {
                            return h('div', {
                                class: 'ellipsis  resource',
                                style: { position: 'relative' }
                            }, [
                                h(
                                    'div',
                                    {
                                        class: 'ellipsis',
                                        style: { width: '170px', paddingTop: '5px', height: '50px' }
                                    },
                                    [
                                        h('div',
                                            {
                                                class: 'ellipsis name',
                                                style: {
                                                    cursor: params.row.productName === '云主机' ? 'pointer' : '',
                                                    color: params.row.productName === '云主机' ? '#1f68b3' : ''
                                                },
                                                attrs: {
                                                    title: params.row.name

                                                },
                                                on: {
                                                    click: () => {
                                                        params.row.productName === '云主机' && this.hasPermission('CB0101') && this.toHostDetail(params.row)
                                                    }
                                                }
                                            },
                                            params.row.name
                                        ),
                                        h(
                                            'div',
                                            {
                                                class: 'ellipsis',
                                                style: { width: '170px', color: '#666', paddingBottom: '5px' },
                                                attrs: {
                                                    title: params.row.id
                                                }
                                            },
                                            params.row.id
                                        ),
                                        h(
                                            'Tooltip',
                                            {
                                                class: 'rc-tips copyId',
                                                style: { position: 'absolute', left: '175px', top: '26px', width: '15px' },
                                                props: {
                                                    transfer: true,
                                                    placement: 'top',
                                                    theme: 'light',
                                                    content: this.$t('复制ID')
                                                }
                                            },
                                            [
                                                h('Icon', {
                                                    class: 'copy-icon',
                                                    style: { color: '#1f68b3', 'font-size': '14px' },
                                                    props: {
                                                        type: 'ios-browsers-outline'
                                                    },
                                                    on: {
                                                        click: () =>
                                                            this.copylink(
                                                                params.row.id
                                                            )
                                                    }
                                                })
                                            ]
                                        )
                                    ]
                                )
                            ])
                        }
                    },
                    {
                        title: this.$t('云环境'),
                        key: 'cloudEnvName',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 200,
                        render: (h, params) => {
                            return h('p', { attrs: { title: params.row.cloudEnvName }, class: { 'rc-ellipsis': true } }, [
                                h('i', { class: this.envIcon(params.row.cloudEnvType), style: 'margin-right: 0;' }),
                                h('span', { class: 'icon-text' }, !params.row.cloudEnvName ? this.$t('其他') : params.row.cloudEnvName)
                            ])
                        }
                    },
                    {
                        title: this.$t('倒计时'),
                        key: 'countdown',
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        sortable: true,
                        width: 110,
                        renderHeader: (h, params) => {
                            return h('div', { style: { display: 'inline-block' } },
                                [
                                    h('span', this.$t('倒计时')),
                                    h('Tooltip', {
                                        props: { transfer: true, placement: 'right', theme: 'light' }

                                    }, [h('i', {
                                        class: {
                                            'icon-prompt-1-o': true,
                                            'tips-style': true
                                        },
                                        style: {
                                            'font-size': '12px',
                                            'padding-right': '5px',
                                            color: '#2d8cf0',
                                            'margin-left': '5px'
                                        }
                                    }),
                                    h('div', { slot: 'content' }, [
                                        h('p', this.$t('资源过期最大保留时间') + this.dayNumber + this.$t('天') + '，'),
                                        h('p', this.$t('超过后将会被删除'))
                                    ])
                                    ]

                                    )
                                ])
                        },
                        render: (h, params) => {
                            const txt = params.row.countdown && params.row.countdown >= 0 && this.$newTimeComparison(params.row.endTime) ? (params.row.countdown + this.$t('天') + this.$t('后到期')) : (this.$t('已过期') + Math.abs(params.row.countdown) + this.$t('天'))
                            return h('div', [h('span', { attrs: { title: txt }, style: { color: params.row.countdown >= 0 && this.$newTimeComparison(params.row.endTime) ? '#ff6000' : '#999' } }, txt)])
                        }
                    },
                    {
                        title: this.$t('开始') + '/' + this.$t('结束') + this.$t('时间'),
                        key: 'startTime',
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 140,
                        render: (h, params) => {
                            return h('div', [
                                h('div', params.row.startTime),
                                h('div', params.row.endTime)
                            ])
                        }
                    },
                    {
                        title: this.$t('续费状态'),
                        key: 'typeName',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 100,
                        filterMultiple: false,
                        filters: [],
                        filtersKey: 'renewType',
                        render: (h, params) => {
                            return h('p', [
                                h('span', {
                                    style: {
                                        color: params.row.renewName === '不续费' ? '#f00' : (params.row.renewName === '手动续费' ? '#ffc000' : 'rgb(9, 192, 104)')
                                    }
                                }, this.$t(params.row.renewName) + (params.row.renewName === '自动续费' ? ('(' + params.row.renewCycle + this.$t('个月') + ')') : ''))
                            ])
                        }
                    },

                    {
                        title: this.$t('操作'),
                        width: 260,
                        fixed: 'right',
                        render: (h, params) => {
                            return h('div', { class: 'tbl-btn-div' }, [
                                h('a', {
                                    class: { 'disabled-per': !this.hasPermission('CC0806') },
                                    on: { click: () => { this.hasPermission('CC0806') && this.renewClick('batch', params.row) } }
                                }, this.$t('续费')),
                                h('a', {
                                    style: { display: params.row.renewName !== '自动续费' ? 'inline-block' : 'none' },
                                    class: { 'disabled-per': !this.hasPermission('CC0802') || !this.$newTimeComparison(params.row.endTime) },
                                    on: {
                                        click: () => { this.hasPermission('CC0802') && this.$newTimeComparison(params.row.endTime) && this.renewClick('automatic', params.row) }
                                    }
                                }, this.$t('设置自动续费')),
                                h('a', {
                                    style: { display: params.row.renewName === '自动续费' ? 'inline-block' : 'none' },
                                    class: { 'disabled-per': !this.hasPermission('CC0805') || !this.$newTimeComparison(params.row.endTime) },
                                    on: { click: () => { this.hasPermission('CC0805') && this.$newTimeComparison(params.row.endTime) && this.renewClick('cancel', params.row) } }
                                }, this.$t('取消自动续费')),
                                h('a', {
                                    class: { 'disabled-per': params.row.renewName === '不续费' || !this.hasPermission('CC0803') },
                                    on: { click: () => { !(params.row.renewName === '不续费') && this.hasPermission('CC0803') && this.renewClick('noRenew', params.row) } }
                                }, this.$t('到期不续费'))
                            ])
                        }
                    }
                ]
            }
        }
    },
    created () {
        // 清除renewList
        sessionStorage.removeItem('renewList')
        this.getProjectData()
    },
    methods: {
        // 云主机
        toHostDetail (row) {
            this.$router.push({
                path: `/mgt/host/${row.id}/detail`,
                query: { envType: row.cloudEnvType, quote: 'host' }
            })
        },
        // 刷新表格
        refresh () {
            this.$refs.rcTable.refreshTable()
        },
        // 续费状态
        getRenewType () {
            this.axios.get(this.urlFormat(API.GET_CODE_DATA + '/param', true), {
                params: {
                    codeCategory: 'RENEW_TYPE'
                }
            }).then(res => {
                if (res) {
                    const data = []
                    res.forEach(item => {
                        data.push({ value: item.codeValue, label: this.$t(item.codeDisplay) })
                    })
                    this.tableAttr.columns[5].filters = data
                    this.loading = false
                }
            }).catch(e => {
                this.loading = false
            })
        },
        // 项目
        getProjectData: function () {
            this.axios.get(this.urlFormat(API.GET_ACCESS_POLICES_ID_PROJECT, false, [this.$store.state.user.currentUser.info.userSid])).then(res => {
                const arr = []
                res.forEach(r => {
                    arr.push({ id: r.orgSid, name: r.orgName })
                })
                this.projectList = [{ id: 'all', name: this.$t('全部资源') }].concat(arr)
                this.projectId = this.projectList[0].id
                this.getCloudAndProducts('one')
            })
        },
        // 根据项目查询类型和云环境
        getCloudAndProducts (data) {
            this.axios.get(this.urlFormat(API.GET_RENEW_PRODUCT_AND_CLOUD, false), {
                params: {
                    projectId: this.projectId === 'all' ? null : this.projectId
                }
            }).then(res => {
                this.getRenewType()
                const cloud = [{ cloudEnvId: 'all', cloudEnvName: this.$t('全部') }]
                const products = [{ productType: 'all', productName: this.$t('全部') }]
                if (res && res.cloud) {
                    res.cloud.forEach(item => {
                        cloud.push(item)
                    })
                }
                if (res && res.products) {
                    res.products.forEach(item => {
                        products.push(item)
                    })
                }
                this.products = products// 产品类型
                this.cloud = cloud// 产品类型
                // 第一次加载，不需要刷新表格；切换项目，重新渲染查询条件，刷新表格
                if (!data) {
                    this.$nextTick(function () {
                        this.refresh()
                    })
                }
            })
        },
        // 切换项目
        projectClick (id) {
            // 切换项目，重新获取产品类型/云环境
            this.productType = 'all'
            this.cloudEnvId = 'all'
            this.tableAttr.source.params.productType = null
            this.tableAttr.source.params.cloudEnvId = null
            this.tableAttr.source.params.project = (id === 'all' ? null : id)
            this.getCloudAndProducts()
        },
        // 表格勾选
        selectedChange (selection) {
            this.selected = selection
            this.isNoRenew = false
            this.isAutomatic = false
            for (let i = 0; i < this.selected.length; i++) {
                if (this.selected[i].renewName === '不续费') {
                    this.isNoRenew = true
                }
                if (this.selected[i].renewName === '自动续费') {
                    this.isAutomatic = true
                }
            }
        },
        // 赛选条件
        searchClick (data, type) {
            const id = (data === 'all' ? null : data)
            if (type === 'countdown') {
                // 时间
                this.countdown = data
                this.tableAttr.source.params.countdown = id
            } else if (type === 'type') {
                // 类型
                this.productType = data
                this.tableAttr.source.params.productType = id
            } else if (type === 'cloudEnv') {
                // 云环境
                this.cloudEnvId = data
                this.tableAttr.source.params.cloudEnvId = id
            }
            this.$nextTick(function () {
                this.refresh()
            })
        },
        // 导出
        exportFile () {
            this.loadingTxt = '导出中'
            this.loading = true
            // 查询条件
            let params = ''
            if (this.countdown !== 'all') {
                params += '?countdown=' + this.countdown
            }
            if (this.productType !== 'all') {
                params += (this.countdown !== 'all' ? '&' : '?') + ('productType=' + this.productType)
            }
            if (this.cloudEnvId !== 'all') {
                params += ((this.countdown === 'all' && this.countdown === 'all') ? '?' : '&') + ('cloudEnvId=' + this.cloudEnvId)
            }
            const [userSid] = [this.$store.state.user.currentUser.info.userSid, '', '']
            this.axios({
                method: 'get',
                url: this.urlFormat(API.GET_RENEW_EXPORT + params, false),
                headers: {
                    token: userSid
                },
                responseType: 'blob'
            }).then(res => {
                if (res) {
                    // 文件下载
                    // const blob = new Blob([res], {
                    //     type: 'application/vnd.ms-excel'
                    // })
                    // let link = document.createElement('a')
                    // link.href = URL.createObjectURL(blob)
                    // link.setAttribute('download', '续费资源文件.xlsx')
                    // link.click()
                    // link = null
                    this.$Message.success(this.$t('导出成功'))
                    this.loadingTxt = '加载中'
                    this.loading = false
                }
            }).catch(e => {
                this.$Message.error(this.$t('导出失败'))
                this.loadingTxt = '加载中'
                this.loading = false
            })
        },
        // 续费操作
        renewClick (type, data) {
            if (data) {
                sessionStorage.renewList = JSON.stringify([data])
            } else {
                sessionStorage.renewList = JSON.stringify(this.selected)
            }
            this.$nextTick(() => {
                let renewType = null
                if (type === 'automatic') {
                    // 自动续费
                    renewType = 'auto'
                } else if (type === 'noRenew') {
                    // 不续费
                    renewType = 'none'
                }
                if (type === 'batch' || type === 'automatic' || type === 'noRenew') {
                    // 续费/自动续费/不续费
                    this.$router.push({
                        path: '/mgt/renew/detail',
                        query: {
                            type: type,
                            renewType: renewType
                        }
                    })
                } else if (type === 'export') {
                    // 导出
                    this.exportFile()
                } else if (type === 'expireDate') {
                    // 设置统一到期日
                    this.$refs.expirationtime.open()
                } else if (type === 'cancel') {
                    // 取消自动续费
                    this.cancelClick(data)
                }
            })
        },
        // 取消自动续费
        cancelClick (data, type) {
            this.$Modal.confirm({
                okText: this.$t('确定'),
                cancelText: this.$t('取消'),
                title: this.$t('确定要取消自动续费设置?'),
                content: this.$t('取消后将恢复为手动续费，也可重新设置为自动续费。'),
                onOk: () => {
                    this.axios.put(this.urlFormat(API.PUT_RENEW_TYPE, false), {
                        ids: [data.id],
                        renewType: 'manual'
                    }).then(res => {
                        this.refresh()
                    })
                }
            })
        },
        // 复制剪切板
        copylink (id) {
            this.copyId = id
            this.$nextTick(() => {
                const copyrelay = this.$refs.copyrelay
                copyrelay.select()
                document.execCommand('Copy')
                this.$Message.success(this.$t('ID复制成功'))
            })
        }
    }
}
</script>
<style lang="less" scoped>
.renew-content {
    position: relative;
    .module-container {
        padding-top: 0px;
        margin-top: -5px;
    }
    button {
        i {
            vertical-align: middle;
        }
    }
    .searchCondition {
        font-size: 12px;
        padding: 20px 0 5px 0;
        background: #f5f6f7;
        margin: 0px 0 15px 0;
        li {
            height: 45px;
            clear: both;
            ul {
                margin: 0;
                padding: 0;
                li {
                    padding: 0px 10px;
                    height: 40px;
                    line-height: 40px;
                    margin: 0;
                    .ivu-select-dropdown {
                        padding: 0;
                    }
                }
            }
            label {
                width: 100px;
                text-align: right;
                color: #808080;
                display: inline-block;
                float: left;
                padding: 5px 0px;
            }
            p {
                width: calc(~'100% - 100px');
                display: inline-block;
                span {
                    cursor: pointer;
                    display: inline-block;
                    padding: 0px 10px;
                    line-height: 25px;
                    // background: #eee;
                    border: 1px dotted #ddd;
                    margin: 0 7px 5px 7px;
                    min-width: 90px;
                    text-align: center;
                }
                span:hover {
                    border: 1px solid #1f68b3;
                }
                .curr {
                    border: 1px solid #1f68b3;
                    background: #f2f8fe;
                    position: relative;
                    // color: #fff;
                }
                .curr:after {
                    content: '';
                    position: absolute;
                    right: -1px;
                    bottom: -1px;
                    width: 16px;
                    height: 16px;
                    background-image: url(../../../assets/images/console/curr_bg.png);
                    background-position: 70.63% 81.08%;
                    background-repeat: no-repeat;
                }
            }
        }
    }
    .copy-el {
        opacity: 0;
        height: 1px;
        overflow: hidden;
        margin: 0;
        padding: 0;
    }
}
</style>
<style lang="less">
.newRcTable .rcTable-content .ellipsis > div.copyId {
    opacity: 0;
}
.newRcTable .rcTable-content .ellipsis > div {
    .copyId {
        opacity: 0;
    }
}
.newRcTable .rcTable-content .ellipsis > div:hover {
    .copyId {
        opacity: 1;
    }
}
.newRcTable .rcTable-content .ellipsis > div {
    .name {
        line-height: 22px;
    }
    .copyId {
        line-height: 22px;
    }
}
.renew-content .ivu-spin-text {
    display: block !important;
    margin-left: -12px;
    margin-top: 5px;
}
</style>
